/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class RoleDefinitionDto extends JSONable{
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  description: string | undefined = undefined;
  platformRole: boolean | undefined = undefined;
  initialRole = false;
  originalRoleDefinitionUuid: string | undefined = undefined;
  owner: string | undefined = undefined;
  validFrom: Date | undefined = undefined;
  validTo: Date | undefined = undefined;
  companyType?:string;
}
